import React, { FC, useEffect } from 'react';
import { Button, Form, FormItem, Header, Input, ScrollView } from '$uikit';
import { useRoute } from 'react-router5';
import { useOffer, useTranslator } from '$hooks';
import { offersActions, offersSelector } from '$store/offers';
import { useDispatch, useSelector } from 'react-redux';
import { batchActions } from '$store';
import { attachActions, attachPhotosSelector } from '$store/attach';
import { AttachPhoto } from '$store/models';
import { RootState } from '$store/rootReducer';
import { Loader } from '$shared/components';
import { BundleAttach } from '$core/CreateBundle/BundleAttach/BundleAttach';

export const EditOffer: FC = () => {
  const { route } = useRoute();
  const offerId = +route.params.offer_id;
  const offer = useOffer(offerId);
  const dispatch = useDispatch();
  const { edit } = useSelector(offersSelector);
  const content: AttachPhoto[] = useSelector((state: RootState) =>
    attachPhotosSelector(state, 'edit_offer'),
  );
  const t = useTranslator();

  useEffect(() => {
    if (!offer) {
      dispatch(offersActions.loadOffer(offerId));
    } else if (edit.offerId !== offerId) {
      dispatch(
        batchActions(
          offersActions.editOfferFormFill(offer),
          attachActions.initFromAttachments({
            pickerId: 'edit_offer',
            attachments: offer.content,
          }),
        ),
      );
    }
  }, [offer]);

  const handleDescription = (e) => {
    dispatch(
      offersActions.editFormUpdate({
        description: e.target.value,
      }),
    );
  };

  const handleSave = () => {
    dispatch(offersActions.editOffer(offerId));
  };

  function renderContent() {
    if (!offer) {
      return <Loader />;
    }

    return (
      <Form>
        <FormItem
          title={t('offer_create_description_title')}
          description={t('offer_create_description_caption')}
        >
          <Input
            placeholder={t('offer_create_description_placeholder')}
            value={edit.description}
            onChange={handleDescription}
            multiline
          />
        </FormItem>
        <FormItem
          title={t('offer_create_content_title')}
          titleAfter={`${content.length}/30`}
          descriptionBeforeContent
          description={t('offer_create_content_caption')}
        >
          <BundleAttach pickerId="edit_offer" decryptKey="" limit={30} />
        </FormItem>
        <FormItem>
          <Button onClick={handleSave}>{t('save')}</Button>
        </FormItem>
      </Form>
    );
  }

  return (
    <>
      <Header showCloseButton>{t('edit_offer_title')}</Header>
      <ScrollView>{renderContent()}</ScrollView>
    </>
  );
};
